module.exports = __webpack_public_path__ + "img/default_avatar.78f1dea9.png";